module.exports = __webpack_public_path__ + "img/mgw-prestige.06e84585.png";